import React from "react";
import { useEffect, useState } from "react";
import DashboardCard from "../../../components/DashboardCard";
import MyFiles from "../../../assets/images/MyFiles.svg";
import { useHistory } from "react-router-dom";
import Tooltip from "react-tooltip";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { InformationCircleIcon, PrinterIcon } from "@heroicons/react/24/solid";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { PERMISSIONS } from "../../PermissionsConstants";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import {
  mainSelectedTab,
  permittedTabs,
} from "../../CarrierAgreementMgmt/atoms";
import { RedirectTo } from "../../../routes/RedirectTo";
import { useGetLeasedEquipmentCount } from "../../CarrierAgreementMgmt/LeasedEquipment/hooks/useGetLeasedEquipmentCount";

const NewLeasedEquipmentCard = () => {
  const { data: leasedEquipment } = useGetLeasedEquipmentCount();
  const leasedEquipmentCount = leasedEquipment?.data;

  const [caCount, setCACount] = useState("...");
  const modulePermission = PERMISSIONS.permission_leasedequipment_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  const useraccount = useRecoilValue(accountAtom);

  const history = useHistory();
  const [connection, setConnection] = useState<any>(null);

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [usersTabs] = useRecoilState(permittedTabs);

  return (
    <div
      className="relative p-2 bg-white text-primary rounded-lg animate-fade-in-down2 shadow-md hover:text-white hover:bg-btnolSave"
      onClick={() => {
        if (userPermissions.includes(modulePermission)) {
          const urlPath = "/officesettings/leasedequipment";
          history.push({
            pathname: urlPath,
          });
        }
      }}
    >
      <DashboardCard
        text="Leased Equipment"
        count={leasedEquipmentCount}
        image={
          <PrinterIcon className="text-white bg-btnolSave rounded-md h-7 w-7 p-1" />
        }
        hasAccess={userPermissions.includes(modulePermission)}
      />
    </div>
  );
};

export default NewLeasedEquipmentCard;
